<template>
  <div class="lightingMenuWrap">
    <el-date-picker
      v-model="timeData"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :clearable="false"
      unlink-panels
      format="yyyy-MM-dd"
      value-format="timestamp"
      style="margin-left: 20px"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
    <el-cascader
      v-model="defaultId"
      :options="dataList"
      :show-all-levels="false"
      :props="{
        checkStrictly: true,
        value: 'id',
        label: 'name',
        emitPath: false,
      }"
      :clearable="false"
      style="margin: 0 20px"
    ></el-cascader>
    <el-radio-group
      v-model="showX"
      size="small"
      fill="#66b1ff"
      v-if="$route.path == '/lightingYOM'"
    >
      <el-radio-button label="小时"></el-radio-button>
      <el-radio-button label="天"></el-radio-button>
    </el-radio-group>
    <el-button type="primary" @click="onSubmit" style="margin-left: 20px"
      >查询</el-button
    >
  </div>
</template>

<script>
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
export default {
  data() {
    return {
      timeData: [],
      defaultId: null,
      dataList: [],
      showX: "天",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
    };
  },
  methods: {
    onSubmit() {
      if (
        dateFtt("yyyy-MM-dd", new Date(this.timeData[1])) ===
        dateFtt("yyyy-MM-dd", new Date())
      ) {
        this.timeData[1] = new Date(
          dateFtt("yyyy-MM-dd hh:mm:ss", new Date())
        ).getTime();
      } else {
        this.timeData[1] = new Date(
          dateFtt("yyyy-MM-dd 23:59:59", new Date(this.timeData[1]))
        ).getTime();
      }
      // console.log(
      //   dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.timeData[0])),
      //   dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.timeData[1]))
      // );
      let dayNum =
        (this.timeData[1] - this.timeData[0]) / (1000 * 60 * 60 * 24);
      // console.log(dayNum);
      if (dayNum >= 8 && this.showX == "小时") {
        this.$message.warning("选择小时展示时间跨度不能超过一周！");
        return false;
      }
      if (dayNum >= 366) {
        this.$message.warning("查询时间跨度不能超过一年！");
        return false;
      }
      this.$emit("getSelectData", {
        timeData: this.timeData,
        defaultId: this.defaultId,
        showX: this.showX,
      });
    },
    getTimeData() {
      let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
      let end = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.timeData = [start.getTime(), end.getTime()];
    },
    async getMenu() {
      let res = await api.systemGetTreeData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId,
        type: "照明系统",
      });
      if (res.status == 200) {
        this.dataList = [];
        this.dataList.push(res.data);
        if (this.dataList.length && this.dataList[0].children) {
          this.defaultId = this.dataList[0].children[0].id;
        } else {
          this.defaultId = this.dataList[0].id;
        }
        this.onSubmit();
      }
    },
  },
  created() {
    this.getTimeData();
    this.getMenu();
  },
};
</script>

<style>
</style>